import { SingleTabType } from '@/utils/constant';
import { Button, Col, Modal, Row } from 'antd';
import React from 'react';
const ReminderModal = ({
  vehicleName,
  remindReportModal,
  setRemindReportModal,
}: {
  vehicleName: string;
  remindReportModal: boolean;
  setRemindReportModal: AnyFunc;
}) => {
  return (
    <>
      <Modal
        open={remindReportModal}
        onCancel={() => setRemindReportModal(false)}
        destroyOnHidden
        centered
        footer={
          <>
            <Button
              type='primary'
              onClick={() => {
                setRemindReportModal(false);
                window.open(
                  `${location.protocol}//${process.env.JDX_APP_JDX_MONITOR}/app/single?license=${vehicleName}&rightTab=${SingleTabType.ACCIDENT}`,
                  '_blank',
                );
              }}
            >
              查看详情
            </Button>
          </>
        }
      >
        <Row justify={'start'} align={'middle'}>
          <Col>
            <img
              src={require('@/assets/img/views/instruct/warning_icon.png')}
              style={{ marginRight: '8px' }}
            ></img>
          </Col>
          <Col style={{ color: '#fff' }}>
            碰撞车辆{vehicleName}未操作「事故排查」，请处理后再关单！
          </Col>
        </Row>
      </Modal>
    </>
  );
};
export default React.memo(ReminderModal);
